/* eslint-disable import/prefer-default-export */
import request from '../utils/request';
import { exportExcel } from '../utils/tools';

// 获取开票订单列表
export const billingOrderList = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceOrder/orderGrid',
  method: 'post',
  data,
});

// 获取开票主体
export const billingEntity = (data, corpCode) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceParam/paramGrid',
  method: 'post',
  data,
  corpCode,
});

// 获取税收分类编号
export const taxNumber = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceParam/getParamById',
  method: 'post',
  data,
});

// 获取免税率
export const freeRateList = (data) => request({
  url: '/pubs/manage/pubs-admin/admin/param/getParamValues?code=freeRate',
  method: 'post',
  data,
});

// 检查开票类型
export const invoiceModelCheck = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceOrder/invoiceModelCheck',
  method: 'post',
  type: 'json',
  data,
});

// 开票
export const createInvoiceReq = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceList/createInvoiceReq',
  method: 'post',
  type: 'json',
  data,
});

// 模糊搜索企业名称
export const queryEnterpriseByname = (data) => request({
  url: '/pubs/manage/eInvoice/api/einvoiceList/queryEnterpriseByname',
  method: 'post',
  data,
});

// 冻结
export const einvoiceOrderFrozen = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceOrder/frozen',
  method: 'post',
  type: 'json',
  data,
});

// 冻结
export const einvoiceOrderUnfrozen = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceOrder/unFrozen',
  method: 'post',
  type: 'json',
  data,
});

// 模糊搜索开票主体
export const querySaleDutyByname = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceParam/saleDutyQueryByCorpCodeAndName',
  method: 'post',
  type: 'json',
  data,
});

// 导出
export const exportExcelRecords = (params) => exportExcel({
  url: '/pubs/manage/eInvoice/webApi/einvoiceOrder/export',
  params,
});




//////////////////
// WEBPACK FOOTER
// ./node_modules/@sditest/electronic-invoice-api/src/api/orderBilling.js
// module id = KVEh
// module chunks = 70